import { render, staticRenderFns } from "./PrivacyFl.vue?vue&type=template&id=3e06d527&scoped=true"
import script from "./PrivacyFl.vue?vue&type=script&lang=js"
export * from "./PrivacyFl.vue?vue&type=script&lang=js"
import style0 from "./PrivacyFl.vue?vue&type=style&index=0&id=3e06d527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06d527",
  null
  
)

export default component.exports